import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SidebarService } from '../../../../_services/sidebar.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  animations: [
    trigger('slide', [
      state('up', style({ height: 0 })),
      state('down', style({ height: '*' })),
      transition('up <=> down', animate(200))
    ])
  ]
})
export class SidebarComponent implements OnInit {
  menus = [];
  constructor(public sidebarservice: SidebarService) {
    this.menus = sidebarservice.getMenuList();
   }
  ngOnInit() {
  }
  getSideBarState() {
    return this.sidebarservice.getSidebarState();
  }
  toggle(currentMenu) {
    if (currentMenu.type === 'dropdown') {
      this.menus.forEach(element => {
        if (element === currentMenu) {
          currentMenu.active = !currentMenu.active;
        } else {
          element.active = false;
        }
      });
    }
  }
  getState(currentMenu) {
    if (currentMenu.active) {
      return 'down';
    } else {
      return 'up';
    }
  }
  hasBackgroundImage() {
    return this.sidebarservice.hasBackgroundImage;
  }

openNewWindow(emailus)
    {
        window.open(emailus,'_blank','toolbar=no,menubar=no,resizable=no,scrollbars=auto,status=no,location=no,width=360,height=220');
    }
    openNewWindowContactUs(contactus)
    {
        window.open(contactus,'_blank','toolbar=no,menubar=no,resizable=no,scrollbars=auto,status=no,location=no,width=360,height=290');
    }
  }